import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "fixed bg-white shadow-lg right-0 my-2 z-20 rounded flex justify-self-center flex-col"
}
const _hoisted_3 = ["onClick"]

import { ref, onMounted, onUnmounted, shallowRef } from "vue";
import DialogComponent from "../doalog/DialogComponent.vue";
import AffiliatePayout from "../doalog/inside/AffiliatePayout.vue";

export interface IDropdownButtonChildren {
  label: string;
  class?: string;
  isConfirm?: boolean;
  action?: () => any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownButton',
  props: {
  type: String,
  title: String,
  children: Object as () => IDropdownButtonChildren[],
  data: Object as () => any,
},
  setup(__props) {

const props = __props



const components = shallowRef({
  use: undefined,
});

const title = ref("Approve/Reject");
const showDropdown = ref(false);
const showConfirm = ref(false);
const dialogConfig = ref({
  title: "",
  confirm: false,
  action: undefined,
});

const onSetData = (data: typeof dialogConfig.value, setShow: boolean) => {
  dialogConfig.value = data;
  showConfirm.value = setShow;
};

const checkOutside = (e: any) => {
  if (e.target.id !== "dropdownBtn") {
    showDropdown.value = false;
  }
};

onMounted(() => {
  if (props.type === "affiliate payout") {
    components.value.use = AffiliatePayout;
  }
  window.addEventListener("click", (e) => checkOutside(e));
});

onUnmounted(() => {
  window.removeEventListener("click", (e) => checkOutside(e));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        id: "dropdownBtn",
        class: "bg-blue-500 text-white rounded px-2 py-1 focus:ring ring-3 ring-offset-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showDropdown.value = !showDropdown.value))
      }, _toDisplayString(title.value), 1),
      (showDropdown.value)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.children, (child, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(["hover:shadow-lg w-full text-center p-4", child?.class]),
                onClick: ($event: any) => (
          child.isConfirm
            ? onSetData(
                {
                  confirm: child.isConfirm,
                  title: child.label,
                  action: child?.action,
                },
                true
              )
            : child.action
        ),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (showDropdown.value = false))
              }, _toDisplayString(child.label), 43, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (dialogConfig.value.confirm)
      ? (_openBlock(), _createBlock(DialogComponent, {
          key: 0,
          title: dialogConfig.value.title,
          show: showConfirm.value,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showConfirm).value = $event)),
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showConfirm.value = false))
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(components).use), {
              data: __props.data,
              config: dialogConfig.value,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (showConfirm.value = false))
            }, null, 40, ["data", "config"]))
          ]),
          _: 1
        }, 8, ["title", "show"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})